import { common } from './common';
import { home } from './home';
import { auth } from './auth';
import { dashboard } from './dashboard';
import profile from './profile';
import progress from './progress';
import { nutritionPlan } from './nutritionPlan';
import onboarding from './onboarding';
import { recipes } from './recipes';
import { productSettings } from './productSettings';
import { shoppingList } from './shoppingList';
import { toast } from './toast';
import { notFound } from './notFound';
import admin from './admin';
import goalForecast from './goalForecast';
import planSummary from './planSummary';
import about from './about';
import contact from './contact';
import privacy from './privacy';
import terms from './terms';
import subscribe from './subscribe';
import suspended from './suspended';
import referral from './referral';
import vip from './vip';

export const en = {
  common,
  home,
  auth,
  dashboard,
  profile,
  progress,
  nutritionPlan,
  onboarding,
  recipes,
  productSettings,
  shoppingList,
  toast,
  notFound,
  admin,
  goalForecast,
  planSummary,
  about,
  contact,
  privacy,
  terms,
  subscribe,
  suspended,
  referral,
  vip,
};
